import { render, staticRenderFns } from "./StandbyBadge.vue?vue&type=template&id=a41d29a2&scoped=true&"
import script from "./StandbyBadge.vue?vue&type=script&lang=js&"
export * from "./StandbyBadge.vue?vue&type=script&lang=js&"
import style0 from "./StandbyBadge.vue?vue&type=style&index=0&id=a41d29a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41d29a2",
  null
  
)

export default component.exports
import {QTooltip} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTooltip})
